// extracted by mini-css-extract-plugin
module.exports = {"goldTab":"styles_goldTab__V0N_H","silverTab":"styles_silverTab___SEYN","bronzeTab":"styles_bronzeTab__CarAu"};